export const NAME = 'taskStatistics';
export const PAGE_SIZE = 3;

export const SEARCH_TYPE = {
	success: 'successRate',
	status: 'status',
};

export const radioOptions = [
	{ name: 'taskStatistics:typeSuccess', code: 'successRate' },
	{ name: 'taskStatistics:typeStatus', code: 'status' },
];

export const statusHeaders = [
	'taskStatistics:seller',
	'taskStatistics:taskType',
	'taskStatistics:openedAfterWarning',
	'taskStatistics:openedAfterDeadline',
];

export const statusKeys = ['taskCountBeforeDeadline', 'taskCountAfterDeadline'];

export const successHeaders = [
	'taskStatistics:seller',
	'taskStatistics:taskType',
	'taskStatistics:fulfilledInTimeOrWarning',
	'taskStatistics:fulfilledLate',
	'taskStatistics:notFulfilled',
	'taskStatistics:success',
	'taskStatistics:failure',
];

export const successKeys = [
	'taskCountBeforeDeadline',
	'taskCountAfterDeadline',
	'taskCountNotDone',
	'taskCountDoneSuccess',
	'taskCountDoneNotSuccess',
];
